import { classToPlain } from "class-transformer";
import { toJS } from "mobx";
import Notice from "../models/notice";

export default function serializeNotice(notice: Notice) {
  return JSON.stringify(
    classToPlain(toJS(notice), {
      excludePrefixes: ["__"],
    }),
    function replacer(key, value) {
      if (key === "base64") {
        return undefined;
      }
      return value;
    }
  );
}
